import withLanguage from "../HOC/withLanguage";

const PrivacyPolicy = ({ language = {} }) => {
  const sections = Object.entries(language);

  console.log("sections", sections);
  return (
    <div className="pb-16 text-gray-700">
      <div className="bg-gradient-to-b from-gray-200 to-white pt-16 pb-10">
        {sections?.map((item, i) => {
          console.log("item", item);
          console.log("item[0]", item[0]);
          return (
            <section className="max-w-6xl mx-auto" key={item[0]}>
              <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
                {/* Title */}
                <h2 className={`text-red-600 mb-5 font-semibold ${i === 0 ? 'text-4xl' : 'text-2xl'}`}>
                  {item[1]?.title}
                </h2>

                {/* Paragraphs */}
                {item[1]?.items && <div>
                  {item[1]?.items?.map((item, index) => (
                    <p key={index} className="mb-5">
                      {item}
                    </p>
                  ))}
                </div>}

                {/* List */}
                {item[1]?.list && <ul className="list-disc space-y-2 pl-5">
                  {item[1]?.list?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>}

              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default withLanguage(PrivacyPolicy, "privacyPolicy");
